export default __webpack_public_path__ + "static/media/profile_background.eaf9762f.png";